export default __webpack_public_path__ + "static/media/Service_Delivery_Manager_Role.11b31532.svg";